import { useRef } from 'react';
import { useTheme } from '@simplywallst/ui-core';
import { useSelector, shallowEqual } from 'react-redux';
import WaterfallChart from '@/components/WaterfallChart';
import { selector } from '../selector';

export function IncomeWaterfall() {
  const theme = useTheme();
  const chartsRef = useRef(['Income Statement']);
  const { current: chart } = chartsRef;
  const keyRef = useRef([
    'Revenue',
    'Cost of Revenue',
    'Gross Profit',
    'Other Expenses',
    'Earnings',
  ]);

  const data = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  if (data === undefined) return null;
  const {
    revenue,
    earnings,
    grossProfit,
    expenses,
    costOfRevenue,
    revenueFormatted,
    earningsFormatted,
    grossProfitFormatted,
    expensesFormatted,
    costOfRevenueFormatted,
  } = data;
  const { current: keys } = keyRef;
  const entities = {
    [chart[0]]: {
      [keys[0]]: revenue,
      [keys[1]]: costOfRevenue,
      [keys[2]]: grossProfit,
      [keys[3]]: expenses,
      [keys[4]]: earnings,
    },
  };
  const entitiesFormatted = {
    [chart[0]]: {
      [keys[0]]: revenueFormatted,
      [keys[1]]: costOfRevenueFormatted,
      [keys[2]]: grossProfitFormatted,
      [keys[3]]: expensesFormatted,
      [keys[4]]: earningsFormatted,
    },
  };
  const entitiesTooltips = {
    [chart[0]]: {
      [keys[0]]: 'Revenue',
      [keys[1]]: 'Cost of Revenue',
      [keys[2]]: 'Gross Profit',
      [keys[3]]: 'Other Expenses',
      [keys[4]]: 'Earnings',
    },
  };
  const entitiesProps = {
    [chart[0]]: {
      [keys[0]]: {},
      [keys[1]]: {
        showTopBar: true,
        renderHeight: revenue > grossProfit ? revenue : grossProfit,
        negativeValueColor: theme.color.badRGBA(0.5),
      },
      [keys[2]]: {},
      [keys[3]]: {
        showTopBar: true,
        renderHeight: grossProfit > earnings ? grossProfit : earnings,
        negativeValueColor: theme.color.badRGBA(0.5),
      },
      [keys[4]]: {},
    },
  };
  return (
    <WaterfallChart
      hideTitle
      canStack={false}
      charts={chart}
      colors={theme.chart.barChart.incomeStatement.colors}
      entities={entities}
      entitiesFormatted={entitiesFormatted}
      entitiesTooltips={entitiesTooltips}
      typography="tinyStrong"
      height={200}
      keys={keys}
      titleColors={theme.chart.barChart.incomeStatement.titleColors}
      entitiesProps={entitiesProps}
    />
  );
}
